// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Ti4g","ranges":"BmiRanges_ranges__wR__J"};